<template>
  <div v-if="exam">
    <b-modal id="deleteExamModal" centered>
      <template #modal-header><h4>Usuwanie egzaminu</h4></template>
      Czy na pewno chcesz usunąć egzamin {{exam.name}}?
      <template #modal-footer>
        <vs-button type="border round" icon-pack="feather" icon="icon-x" @click="$bvModal.hide('deleteExamModal')">
          Anuluj
        </vs-button>
        <vs-button color="danger" icon-pack="feather" icon="icon-trash" type="filled round" @click="deleteExam" class="mr-4">
          Usuń
        </vs-button>
      </template>
    </b-modal>
    <b-container fluid>
      <b-row class="mb-6 mt-6">
        <b-col><h4 class="mb-6">Dane egzaminu</h4></b-col>
        <b-col v-if="$acl.check('admin')">
          <vs-button type="filled round" icon-pack="feather" icon="icon-save"
                     v-if="!disabledForm" class="float-right ml-4" @click="updateExam">
            Zapisz
          </vs-button>
          <vs-button type="border round" icon-pack="feather" :icon="disabledForm ? 'icon-edit-2' : 'icon-x'"
                     class="float-right" @click="toggleFormEdit">
            {{ disabledForm ? 'Edytuj' : 'Anuluj' }}
          </vs-button>
          <vs-button color="danger" type="border round" icon-pack="feather" icon="icon-trash"
                     v-if="disabledForm" class="float-right mr-4" @click="$bvModal.show('deleteExamModal')">
            Usuń
          </vs-button>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <vs-input
            label="Nazwa"
            v-model="exam.name"
            class="w-100 mt-4"
            :disabled="disabledForm"
          />
          <field-error :errorsBag="formErrors" fieldName="name"/>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <vs-textarea
            label="Opis"
            v-model="exam.description"
            class="w-100 mt-4"
            :disabled="disabledForm"
          />
          <field-error :errorsBag="formErrors" fieldName="description"/>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <vs-input
            label="Limit czasu (s)"
            v-model="exam.time_limit"
            class="w-100 mt-4"
            type="number"
            :disabled="disabledForm"
          />
          <field-error :errorsBag="formErrors" fieldName="time_limit"/>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <vs-input
            label="Wymagana ilość punktów (0-1)"
            v-model="exam.score_required_to_pass"
            class="w-100 mt-4"
            type="number"
            :disabled="disabledForm"
          />
          <field-error :errorsBag="formErrors" fieldName="score_required_to_pass"/>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <vs-input
            label="Maksymalna ilość prób"
            v-model="exam.max_attempts"
            class="w-100 mt-4"
            type="number"
            :disabled="disabledForm"
          />
          <field-error :errorsBag="formErrors" fieldName="max_attempts"/>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>

import FieldError from "@/components/wod/forms/FieldError";
import axios from "axios";
import notification from "@/notification";

export default {
  name: 'ExamDetails',
  components:{
    FieldError
  },
  data () {
    return {
      exam: {},
      formErrors: {},
      disabledForm: true,
      payload: {
        max_attempts: null,
        score_required_to_pass: null,
        time_limit: null,
        name: null,
        description: null,
      },
    }
  },
  methods: {
    getExam() {
      axios.get('/ez/exams/'+this.$route.params.uuid)
        .then(response => this.exam = response.data.data)
        .catch( error =>   this.$vs.notify(notification.error(error.message)) )
    },
    deleteExam() {
      axios.delete('/ez/exams/'+this.$route.params.uuid)
        .then(() => {
          this.$vs.notify(notification.success('Egzamin został usunięty'))
          this.$router.go(-1)
        })
        .catch( error => {
          this.$vs.notify(notification.error(error.message))
        })
    },
    updateExam() {
      axios.patch('/ez/exams/'+this.$route.params.uuid, this.exam)
        .then(() => {
          this.disabledForm = true
          this.$vs.notify(notification.success('Egzamin został zaktualizowany'))
          this.getExam()
        })
        .catch( error => {
          this.$vs.notify(notification.error(error.message))
        })
    },
    toggleFormEdit() {
      this.formErrors = {}
      this.disabledForm = !this.disabledForm
    },
  },
  mounted() {
    this.getExam()
  },

}
</script>
